var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6573 27.8559H17.3427C21.1504 27.8559 23.0325 25.9011 22.9996 21.9915C22.9558 17.5266 22.934 14.2834 22.8246 11.851C22.5073 4.69819 20.5268 2.599 14.0055 2.599C7.4842 2.599 5.4928 4.69819 5.17549 11.851C5.06607 14.2834 5.04419 17.5266 5.00042 21.9915C4.9676 25.9011 6.84958 27.8559 10.6573 27.8559ZM10.34 23.4466C9.39901 23.4466 8.79722 22.8245 8.79722 21.8916V16.1605C8.79722 15.2164 9.39901 14.5944 10.34 14.5944H17.671C18.6011 14.5944 19.2028 15.2164 19.2028 16.1605V21.8916C19.2028 22.8245 18.6011 23.4466 17.671 23.4466H10.34ZM8.79722 18.8706H19.2028V17.5488H8.79722V18.8706ZM14.0055 0C11.9047 0 10.4275 1.44389 10.4275 3.4098H11.9703C11.9703 2.33244 12.8019 1.56606 14.0055 1.56606C15.1981 1.56606 16.0407 2.33244 16.0407 3.4098H17.5834C17.5834 1.44389 16.0954 0 14.0055 0Z",
    fill: "#FF9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.7dfcf2478734ee6553cc8a4708ae5bab.svg";
export { ForwardRef as ReactComponent };